import React from "react";
import CSR from "../../assets/images/benefits/csr.svg";
import Networking from "../../assets/images/benefits/networking.svg";
import certification from "../../assets/images/benefits/cerification.svg";
import HiveMonitoring from "../../assets/images/benefits/traceability.svg";
import USPSection2Cards from "../../components/USPSection2/USPSection2Cards";
import { Row, Col } from "react-bootstrap";

const EcoContribtorBenefits = () => {
  const benefits = [
       {
      title: "Enhancing Corporate Social Responsibility (CSR)",
      bodycopy:
        "Eco-Bee adoption can be a key component of an organization’s CSR strategy, demonstrating commitment to social causes and biodiversity.",
      image: CSR,
    },
  
    {
      title: "Collaboration and Networking",
      bodycopy:
        "Engaging in eco-contribution projects opens opportunities for partnerships with like-minded organizations and individuals, creating a network of socially responsible allies.        ",
      image: Networking,
    },
    {
      title: "Adoption Certificate",
      bodycopy:
        "After adopting the Eco-Bee, eco-contributors receive a confirmation certificate detailing their commitment to sustainability and  biodiversity.",
      image: certification,
    },
 

    
    {
      title: "Adopted Hive Monitoring, Transparency and Impact Tracking",
      bodycopy:
        "Eco-contributors have access to real-time monitoring, giving them visibility into the impact of their support, which can be used in annual reports and marketing materials to validate the effectiveness of their sustainability efforts.  ",
      image: HiveMonitoring,
    },
    
   
  ];
  return (
    <>
      {" "}
      <Row>
        {benefits.map((e) => {
          return (
            <Col md={4}>
              <USPSection2Cards
                cardtitle={e.title}
                src={e.image}
                cardBodycopy={e.bodycopy}
              />
            </Col>
          );
        })}
      </Row>
    </>
  );
};

export default EcoContribtorBenefits;
